import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "./SideMenu";
import Footer from "./Footer";
import Header from "./Header";
import Logout from "./Logout";
import { strings } from "../Utilities/strings";
// for Sidebar And Navbar
import Search from "../images/search.png";
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Add_Icon from "../images/Add_Icon.svg";
import Edit_Icon from "../images/edit_icon.svg";
import searchIcon from "../images/search_icon.svg";
import { modalCustomStyles } from "../Utilities/utils";
import Pagination from "../Utilities/Pagination";

//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import { addMainAsset, getMainAssets } from "../Utilities/URLCONSTANTS";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";

import Loader from "../Utilities/Loader";
import * as XLSX from "xlsx"; // Import XLSX as an object
import { customstyles } from "../Utilities/utils";
import Select from "react-select";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";

//AssertMaster
const MainAssertMaster = ({ }) => {
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");
  const [errorStatus, setErrorStatus] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [errorName, setErrorName] = useState("");
  const [buttonText, setButtonText] = useState("Submit");
  const [sno, setSno] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState(
    "Do you want to close Main Asset Master"
  );
  ///modal popup
  const [showModal, setShowModal] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [error, setError] = useState("");
  const [modalData, setModalData] = useState({
    id: "",
    assetName: "",
    description: "",
    Status: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [data, setData] = useState([]);
  const [loaderImage, setLoaderImage] = useState(
    require("../images/cs_loader.gif")
  );
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter(
        (item) =>
          item.mainAssetName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.status.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filteredResults);
      handlePageClick(1)
    }
  };

  useEffect(() => {
    if (data != null && data != undefined) {
      //  const totalItems = data.length;
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination logic

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };
  const exportToExcel = () => {
    const data = [
      ["S.no", "main Asset Name", "Description", "Status"], // Custom headers
      // ...currentItems.map((item) => [
      ...filteredData.map((item) => [
        item.id,
        item.mainAssetName,
        item.description,
        item.status === "1" ? "Active" : "InActive",
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    // Save the file
    XLSX.writeFile(wb, "MainAssert.xlsx");
  };

  const handleCancel_new = () => {
    //no
    // alert("handleCancel");
    setShowModal(true);
    setShowPopup(true);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };
  const handleCancel = () => {
    setShowModal(true);
    setShowPopup(false);
    setShowMsg(true);
    // window.location.reload();
  };
  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };

  // ...more items
  // const handleNameChange = (e) => {
  //   const input = e.target.value;
  //   if (input.length > 0) {
  //     setErrorName("");
  //   }
  //   const result = input.replace(/[^a-z_\s]/gi, "");
  //   setName(result);
  // };

  const handleNameChange = (e) => {
    const input = e.target.value;
    if (input.length > 0) {
      setErrorName("");
    }
    const result = input
      .replace(/[^a-z_\s]/gi, "")
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    setName(result);
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
    if (e.target.value) {
      setErrorStatus("");
    }
  };
  // const handleDescriptionChange = (e) => {
  //   const input = e.target.value;
  //   setDescription(input);
  //   if (input.length > 0) {
  //     setErrorDescription("");
  //   }
  // };

  const handleDescriptionChange = (e) => {
    const input = e.target.value;
    const result = input
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    setDescription(result);
    if (input.length > 0) {
      setErrorDescription("");
    }
  };

  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "In-Active" },
  ];

  const handleSubmit = async (item) => {
    if (name === "") {
      setErrorName("Please Enter a Main Asset Name");
    }
    if (description === "") {
      setErrorDescription("Please Enter a Description");
    }
    if (status === "") {
      setErrorStatus("Please Enter a Status");
    }
    try {
      if (name !== "" && description !== "" && status !== "") {
        const apiUrl = addMainAsset;
        const headers = await GetApiHeaders();
        const dataToSend = {
          Id: { buttonText } == "Submit" ? "" : id.toString(),
          assetName: name,
          description: description,
          status: status,
        };

        setIsLoading(true);
        // Make the POST request using Axios with headers
        const response = await axios.post(apiUrl, dataToSend, { headers });
        setsubmitResponse(response.data.response);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);

        // Handle the response data as needed
        console.log("Response:", response.data);

        // Proceed with data insertion if the API call was successful
        const newId = String(Date.now());
        const newItem = {
          id: newId,
          assetName: name,
          description: description,
          Status: data.Status,
        };

        setErrorName("");
        setErrorDescription("");
        setErrorStatus("");
        setIsSubmitted(true);
        // setData(prevData => [...prevData, newItem]);
      } else {
        setIsSubmitted(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsSubmitted(false);
      handleUpdate();
    }
  };

  const handleUpdate = () => {
    // Check if required fields are not empty
    if (id !== "" && name !== "" && description !== "" && status !== "") {
      setErrorName("");
      setErrorDescription("");
      setErrorStatus("");

      setIsUpdated(true);
    } else {
      // Handle error if required fields are empty
      setIsUpdated(false);
    }
  };

  const fetchData = async () => {
    const apiUrl = getMainAssets;
    const headers = await GetApiHeaders();

    setIsLoading(true);
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("response", response);
        setData(response.data.response.MainAssetMaster);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  //for data table
  const tableRef = useRef(null);
  useEffect(() => {
    // Check if DataTable is already initialized
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      // Destroy the existing DataTable instance
      $(tableRef.current).DataTable().destroy();
    }

    // Initialize the DataTable
    $(tableRef.current).DataTable({
      ordering: false, // Disable sorting
    });
  }, []);

  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleModalOpen = () => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    setId("");
    setName("");
    setDescription("");
    setStatus("");
    setModalData({
      id: "",
      mainAssetName: "",
      description: "",
      status: "",
    });
  };

  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };

  const updatedItems = (item, index) => {
    setModalData(item);
    setId(item.id);
    setName(item.mainAssetName);
    setDescription(item.description);
    setStatus(item.status);
    setShowModal(true);
    setButtonText("Update");
    setIsSubmitted(false);
    setIsUpdated(false);
  };


  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key]?.toString().toLowerCase();
      const bValue = b[sortConfig.key]?.toString().toLowerCase();
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };


  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text">User Management</h5>
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-0 Sub_role_text">
                          Main Asset Master
                        </h6>
                      </div>
                      <span
                        class="d-inline-block"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Add Main Asset"
                      >
                        <Button
                          variant="primary"
                          className="buttons"
                          onClick={handleModalOpen}
                        >
                          <img
                            src={Add_Icon}
                            alt="Add"
                            className="addicon"
                          />
                          Add
                        </Button>
                      </span>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />
                        &nbsp;
                        <label> Entries</label>
                      </div>

                      <div className="d-flex align-items-center">
                        <div className="search-container">
                          <img
                            src={searchIcon}
                            alt="Search"
                            className="search-icon"
                          />

                          <input
                            type="text"
                            placeholder="Type to Search..."
                            value={searchTerm}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="search-input mr-2"
                          />
                          {searchTerm && (
                            <button
                              type="button"
                              className="search-clear-btn"
                              onClick={() => handleFilter("")}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        &nbsp;
                        <button
                          className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                          onClick={exportToExcel}
                        >
                          Download Excel
                        </button>
                      </div>
                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div className="card-body">
                          <Table className="table table-bordered Content_data_table table-striped">
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("mainAssetName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Main Asset Name
                                    {renderSortIcon("mainAssetName")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("description")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Description
                                    {renderSortIcon("description")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("status")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Status
                                    {renderSortIcon("status")}
                                  </span>
                                </Th>
                                <Th className="text-center">Actions</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {currentItems.length === 0 ? ( // Check if no data is found
                                <Tr>
                                  <Td
                                    colSpan={19}
                                    className="text-center"
                                    style={{ padding: 195, fontSize: 18 }}
                                  >
                                    Data is not available
                                  </Td>
                                </Tr>
                              ) : (
                                currentItems != undefined &&
                                currentItems != null &&
                                currentItems.map((item, index) => (
                                  <Tr>
                                    <Td className="text-left">{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                    <Td>{item.mainAssetName}</Td>
                                    <Td>{item.description}</Td>
                                    <Td className="text-center">

                                      {item.status === "1" ? (
                                        <span style={{ color: "#4A7729" }}>
                                          Active
                                        </span>
                                      ) : (
                                        <span style={{ color: "#FF0000" }}>
                                          In Active
                                        </span>
                                      )}
                                    </Td>
                                    <Td className="text-center">
                                      <div>
                                        <img
                                          src={Edit_Icon}
                                          alt="Edit Main Asset Measure"
                                          title="Edit Main Asset Measure"
                                          className="editicon"
                                          onClick={() => updatedItems(item)}
                                        />
                                      </div>
                                    </Td>
                                  </Tr>
                                ))
                              )}
                            </Tbody>
                            {isLoading && (
                              <Loader
                                loading={isLoading}
                                message={"Fetching Data. Please Wait..!"}
                                loderimage={loaderImage}
                              />
                            )}
                          </Table>
                          {/* Pagination */}

                          <Pagination
                            currentPage={currentPage}
                            totalItems={sortedData.length}
                            itemsPerPage={itemsPerPage}
                            currentItems={currentItems}
                            onPageChange={handlePageClick}
                          />
                        </div>

                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger  close_btn"
                                onClick={handleCancel_new}
                              >
                                {" "}
                                {/*  onClick={closeWarning} onClick={handleModalClose} */}
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                <span className="modal_title">
                                  Main Asset Master
                                </span>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <label
                                    for="exampleInputPassword1"
                                    class="form-label text-md font-weight-600"
                                  >
                                    Main Asset Name
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">

                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Main Asset Name"
                                      value={name}
                                      inputMode="text"
                                      onChange={handleNameChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorName}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12">
                                  <div class="mb-3">
                                    <label
                                      for="exampleInputPassword1"
                                      class="form-label text-md font-weight-600"
                                    >
                                      Description
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <textarea
                                      class="form-control"
                                      style={{ height: 117 }}
                                      id="textAreaExample1"
                                      rows="2"
                                      value={description}
                                      onChange={handleDescriptionChange}
                                    ></textarea>
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorDescription}
                                  </span>
                                </div>

                                <div className="col-md-6 custom-margin">
                                  <label
                                    htmlFor="status"
                                    className="form-label text-md font-weight-600"
                                  >
                                    Status <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <Select
                                      inputId="status"
                                      options={statusOptions}
                                      value={statusOptions.find(
                                        (option) => option.value === String(status)
                                      )}
                                      onChange={(selectedOption) =>
                                        handleStatus({
                                          target: {
                                            name: "status",
                                            value: selectedOption?.value || "",
                                          },
                                        })
                                      }
                                      placeholder="Select Status"
                                      styles={modalCustomStyles}
                                      className="w-100 mb-4"
                                      isSearchable={false}
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorStatus}
                                  </span>
                                </div>
                                {error && (
                                  <span
                                    style={{ color: "red" }}
                                    className="error-message"
                                  >
                                    {error}
                                  </span>
                                )}
                              </div>
                              <div className="row">
                                {isSubmitted ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {strings.recordSubmitted}.
                                  </p>
                                ) : null}
                                {isUpdated ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {strings.updatedSuccessfully}
                                  </p>
                                ) : null}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="bttn"
                                  onClick={() =>
                                    handleSubmit({
                                      id,
                                      name,
                                      description,
                                      status,
                                    })
                                  }
                                >
                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>
                                <Button
                                  variant="danger"
                                  className="bttn"
                                  onClick={handleCancel_new}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Main Asset Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p className="text-center Popup_Text_Colour" >
                                    Are you Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button preventive-header"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showWarningPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Main Asset Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p className="text-center Popup_Text_Colour" >
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Main Asset Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}
          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->
                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};

export default MainAssertMaster;
